import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { SystemRole } from "../variables/constant";

@Injectable({ providedIn: 'root' })
export class CustomerGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;

    if (currentUser && this.authService.userRole$ == SystemRole.CUSTOMER) {
      return true;
    }

    if (state == undefined) {
      this.router.navigate(['/eCert']);
    }
    else {
      this.router.navigate(['/eCert'], { queryParams: { returnUrl: state.url } });
    }
    return false;
  }

}
